<label [class.invalid-field]="formTouchedAndInvalid" [for]="labelId">{{ labelText }}</label>

<div class="date-container flex" [class.invalid-date]="formTouchedAndInvalid">
  <!-- Day input -->
  <input
    class="pl-xs date-input"
    id="day-input"
    type="text"
    placeholder="DD"
    maxlength="2"
    [spellcheck]="spellcheck"
    [attr.data-qa-id]="'day'"
    [formControl]="dayControl"
    (keyup)="removeStrings(dayControl)"
    (blur)="updateSingleDigit(dayControl)"
  />

  <!-- Month input -->
  <input
    #month
    [class.red-placeholder]="formTouchedAndInvalid"
    class="pl-xs date-input"
    id="month-input"
    type="text"
    placeholder="MM"
    maxlength="2"
    [spellcheck]="spellcheck"
    [attr.data-qa-id]="'month'"
    [formControl]="monthControl"
    (keyup)="removeStrings(monthControl)"
    (blur)="updateSingleDigit(monthControl)"
  />

  <!-- Year field -->
  <input
    #year
    [class.red-placeholder]="formTouchedAndInvalid"
    class="pl-xs date-input"
    id="year-input"
    type="text"
    placeholder="YYYY"
    maxlength="4"
    [spellcheck]="spellcheck"
    [attr.data-qa-id]="'year'"
    [formControl]="yearControl"
  />

  <div class="validation-icons p-xxs">
    <!-- Green tick -->
    @if (formTouchedAndValid) {
      <div id="green-tick">
        <lib-fill-tick-round-icon class="icon-green icon-xs"></lib-fill-tick-round-icon>
      </div>
    }

    <!-- Red tick -->
    @if (formTouchedAndInvalid) {
      <div id="red-tick">
        <lib-fill-cross-round-icon class="icon-red icon-xs"></lib-fill-cross-round-icon>
      </div>
    }
  </div>
</div>

<!-- Error message -->
@if (formTouchedAndInvalid) {
  <span id="error-message" class="invalid-field">{{ errorMessage }}</span>
}
